/*
  利用規約ダイアログ
*/

import React from 'react';
import FullScreenDialog from 'js/shared/components/FullscreenDialog';

const TermsOfServiceDialog = (props) => {
  return (
    <FullScreenDialog {...props} title="利用規約">
      <h1>利用規約</h1>
      <p>
        オーダーアールアプリ利用規約（以下「本規約」といいます。）は、株式会社リベライズ（以下「当社」といいます。）が提供する本サービス（第2条に定義します。）の利用に関する条件を定めています。本サービスを利用するためには、本規約に同意していただく必要があります。
      </p>
      <br/>
        
      <h2>第1条　総則</h2>
      <ol>
        <li>
          当社は、当社に本サービスの利用を申し込み、本規約に同意していただいたお客さま（以下「契約者」といいます。）に本サービスを提供します。
        </li>
        <li>
          契約者は、当社が提供する方式により本アプリ（第2条に定義します。）の使用を開始することにより、本規約のすべての内容について同意したものとみなされます。
        </li>
        <li>
          契約者は、当社の承認を受けてユーザー（第2条に定義します。）を定め、本規約に定める義務の一切について自ら誠実に履行し、かつ、ユーザーに誠実に履行させることを確約するものとし、ユーザーによる当該義務の違反について、ユーザーと連帯して責任を負うものとします。
        </li>
        <li>
          本規約は、契約者およびユーザー（以下、合わせて「契約者等」といいます）による本サービスの利用について、当社および当社の委託先と契約者等との間の一切の関係に適用されます。
        </li>
        <li>
          契約者等は、本規約のほかに当社が本サービスに関する利用条件を別途提示した場合には、それらの利用条件も遵守して本サービスを利用するものとします。なお、当社が別途提示する利用条件と本規約の規定が矛盾抵触する場合には、当社が別途提示する利用条件が優先します。
        </li>
        <li>
          当社は、契約者等の承諾を得ることなく本規約を変更することがあり、契約者等は、あらかじめこれを承諾するものとします。ただし、当社が重要な変更と判断した場合には、変更後の本規約は、当社が別途定める場合を除き、当社が契約者等に本規約の変更等について通知または当社Webサイト（https://orderr.biz）に告知した日の翌日から1か月間の周知期間を経過することをもってその効力を生じるものとします。
        </li>
        <li>
          契約者が本規約の変更に同意できない場合には、契約者等はただちに本アプリの使用を中止し（契約者は自己の責任をもってユーザーに本アプリの使用を中止させてください。）、本アプリがインストールされている端末から本アプリをアンインストールするものとします。
        </li>
        <li>
          契約者等が本規約の変更の効力が生じた後に本アプリの利用を継続する場合には、変更後の本規約のすべての内容に同意したものとみなされます。
        </li>
      </ol>

      <h2>第2条　定義</h2>
      <br/>
      <p>
        本規約において、次の各号に定める用語の定義は、当該各号に定めるとおりとします。
      </p>
      <p>
        (1) 「本アプリ」とは、当社が提供する「オーダーアール」をいいます。
      </p>
      <p>
        (2) 「本サービス」とは、本アプリを使用することにより当社が提供する飲食店向けオーダーシステム「オーダーアール」をいいます。
      </p>
      <p>
        (3) 「本契約」とは、当社と契約者との間の本サービスの利用に関する契約をいいます。
      </p>
      <p>
        (4) 「ユーザー」とは、契約者と雇用、請負、委任その他本サービスの利用を必要とする契約関係にある自然人であり、本サービスへのログインについて、契約者から承認を受けて本サービスを利用する者をいいます。
      </p>
      <p>
        (5) 「カスタマー」とは、本サービスを導入いただいた店舗等の顧客ないし利用者として本アプリを通じて契約者に情報提供等を行う自然人または法人であり、契約者が本アプリを使用して個人情報、写真データ等の各種情報を管理する第三者をいいます。
      </p>
      <p>
        (6) 「アカウント」とは、本サービスの利用開始にあたり、当社が契約者に対して発行する本アプリの使用のために必要なログインＩＤおよびパスワード、ならびに契約者が当社の承認を条件としてユーザーに対して発行する本アプリの使用のために必要なログインＩＤおよびパスワードをいいます。
      </p>
      <br/>

      <h2>第3条　利用申込みおよび利用契約の成立</h2>
      <ol>
        <li>
          本サービスの利用申込みは、本規約の内容を理解した上で、当社が定める方法により提供する利用申込フォームに必要事項を記入し、当社が求める資料等とともに当社に提出する方法により行うものとします。
        </li>
        <li>
          本契約は、当社が前項の利用申込みを受理した後、本サービスの利用申込みを行った者（以下「利用申込者」といいます。）が本規約の内容に同意した上で、当社が提供する本アプリの使用を開始したとき、または第三者に本アプリの使用を開始させたときに本規約の条件に従って成立するものとします。
        </li>
        <li>
          利用申込者について、以下の各号のいずれかに該当する場合には、当社は、本サービスの利用申込みを受理しないことがあります。なお、当社は、利用申込みを受理しない理由について一切の開示義務を負わないものとします。
          <br/>
          <p>
            (1) 本規約に違反する行為を行い、または行うおそれがあると当社が判断する場合
          </p>
          <p>
            (2) 当社に提供された届出事項に虚偽または不備がある場合
          </p>
          <p>
            (3) 過去に本サービスの利用資格を取り消されたことがある場合
          </p>
          <p>
            (4) 当社への必要書類の提出または質問への回答を拒んだ場合
          </p>
          <p>
            (5) 不正な目的または方法により本サービスを利用しようとする場合
          </p>
          <p>
            (6) 第23条第1項各号または第2項各号に該当し、または該当するおそれがあると当社が判断する場合
          </p>
          <p>
            (7) その他、当社が当該利用申込者への本サービスの提供を不適当と判断する場合
          </p>
        </li>
        <li>
          前項の規定により当社が本サービスの利用申込みを受理しなかった場合において、利用申込者が自ら本アプリの使用を開始し、または第三者に使用を開始させていたときは、当社はただちに本アプリの使用を停止させることができるものとし、本契約は本アプリの使用開始時に遡ってその効力を失うものとします。
        </li>
        <li>
          当社が本サービスの利用申込みを受理しなかったことにより利用申込者に生じる不利益について、当社は一切の責任を負わないものとします。
        </li>
      </ol>

      <h2>第4条　メールアドレスの登録および管理</h2>
      <ol>
        <li>
          本サービスの利用にあたり、契約者は自身で使用可能なメールアドレスをアカウントに紐づいたメールアドレスとして登録する必要があります（以下「登録メールアドレス」といいます。）。
        </li>
        <li>
          登録メールアドレスの登録後、登録メールアドレスが使用できなくなった場合には、契約者は、別途当社が指定する方法により、すみやかに他の使用可能なメールアドレスに登録を変更しなければならないものとします。
        </li>
        <li>
          契約者は、登録メールアドレスを自己の責任において管理し、不正利用の防止に努めるとともに、その管理について一切の責任を負うものとします。
        </li>
        <li>
          契約者は、自己の登録メールアドレスが不正に利用されたこと、またはそのおそれがあることを認識した場合には、遅滞なくその旨を当社に報告するものとします。
        </li>
      </ol>

      <h2>第5条　契約内容（届出内容）の変更</h2>
      <ol>
        <li>
          契約者は、本サービスの利用申込み時に当社に届け出た商号、屋号、氏名または住所等の登録事項に変更が生じた場合には、変更があった日から30日以内に、別途当社が指定する方法により、変更があった事項について当社に届け出るものとします。
        </li>
        <li>
          契約者に関して合併、分割、事業譲渡による地位の承継（以下「承継等」といいます。）があった場合には、契約者は、承継等があった日から30日以内に、別途当社が指定する方法により、承継等があった事項について当社に届け出るものとします。
        </li>
        <li>
          当社は、当社が必要と判断した場合には、契約者に対し、前項に定める変更内容を証する書類の提示を求めることができるものとします。
        </li>
        <li>
          契約者から当社に対する変更の届け出の遅滞、遅延または不到達に起因して、当社から契約者または利用者への通知の不到達その他の事由により契約者または利用者が損害を被った場合であっても、当社は一切の責任を負わないものとします。
        </li>
        <li>
          当社は、契約者から変更の届出があった場合において、変更後の契約者または契約者の業務について、従前の契約者または契約者の業務との同一性ないし継続性等が認められないと当社が判断したときは、契約者としての地位の承継を認めない場合があります。
        </li>
      </ol>

      <h2>第6条　利用料金</h2>
      <ol>
        <li>
          本サービスの利用料金は本サービスの利用申込みの際に別途案内するとおりとします。
        </li>
        <li>
          契約者は、指定された支払日（ただし、支払日が土曜日、日曜日、祝日、銀行休業日にあたる場合にはその前日）までに、定められた利用料金を当社が指定する銀行口座に振り込む方法、または銀行引落の方法により支払うものとします。この支払の手続に要する費用は契約者負担とします。
        </li>
        <li>
          契約者が支払日を経過しても利用料金を支払わない場合には、契約者は、支払期日の翌日から支払い済みまで年14.6％の割合の延滞利息（年365日の日割計算により1円未満は切り捨て）を別途支払うものとします。
        </li>
        <li>
          当社は、本規約に別途定めがある場合を除き、当社が契約者から受領した利用料金について、理由のいかんを問わず一切返還する義務を負わないものとします。
        </li>
        <li>
          契約者は、本規約に別途定めがある場合を除き、契約期間中に本契約の解除、解約、利用停止などが生じた場合であっても、解除、解約、利用停止などが生じた日の属する月の末日までの利用料金の全額を支払うものとします。
        </li>
        <li>
          当社は、契約者の事前の承諾を得ることなく利用料金を改定することができるものとし、その手続は第1条第7項ただし書に準じて行うものとします。契約者がこの改定に同意しない場合には、契約者は第12条第3項に従って本契約を解約することができるものとし、契約者が解約の申し出を行うことなく本アプリの使用を継続するときは、利用料金の改定に同意したものとみなします。なお、本項に基づいて契約者が本契約を解約する場合には、第12条第3項の規定にかかわらず、1か月前の事前通知を要しないものとします。
        </li>
      </ol>

      <h2>第7条　費用負担</h2>
      <br/>
      <p>
        本サービスの利用に関して発生する費用は、当社と契約者が別途書面で合意する場合を除き、契約者の負担とします。
      </p>
      <br/>

      <h2>第8条　本サービスの利用環境の整備</h2>
      <ol>
        <li>
          契約者は、自己の責任と費用負担において、当社が定める条件で本サービスの利用に必要な機器および設備を準備し、本サービスを利用するための環境を維持するものとします。
        </li>
        <li>
          本サービスを利用する端末は、契約者等が所有または使用する端末のみとします。
        </li>
        <li>
          契約者は、本サービスを利用するにあたり、自己の責任と費用負担において、電気通信事業者等の電気通信サービスを利用して契約者の機器および設備をインターネットに接続するものとします。
        </li>
        <li>
          契約者の機器もしくは設備、または前項に定めるインターネット接続その他本サービスを利用するための環境に不備または不具合がある場合には、当社は契約者に対して本サービスを提供する義務を負わないものとします。
        </li>
      </ol>

      <h2>第9条　アカウントの発行および管理</h2>
      <ol>
        <li>
          本サービスの利用開始にあたり、契約者等が本サービスにログインするためのアカウントは、当社が提供するフォームに従って契約者が必要な情報を当社に提供し、所定のアカウント登録手続を完了することにより発行されます。
        </li>
        <li>
          契約者が登録したアカウントに起因して契約者等に発生した不利益事項について、当社は一切の責任を負わないものとします。
        </li>
        <li>
          当社が契約者に発行したアカウントは、契約者の責任において厳重に保管および管理するものとし、これを第三者に利用させ、又は貸与、譲渡、名義変更、売買等をしてはならないものとします。
        </li>
        <li>
          当社が契約者に発行したアカウントまたは契約者がユーザーに発行したログインＩＤ（以下「アカウント等」といいます。）により本サービスが利用されているときは、当該アカウント等の発行を受けた契約者等が本サービスを利用しているものとみなし、当該アカウント等でログインしている者が行った行為については、当該アカウント等で登録されている契約者等を対象として本規約の規定が適用されるものとします。
        </li>
        <li>
          アカウント等の保管および管理については、契約者が一切の責任を負うものとし、契約者等のアカウント等が不正に使用されるなどして契約者等に生じた損害について、当社は一切の責任を負わないものとします。
        </li>
        <li>
          契約者等が第三者にパスワードを知られた場合、または知られたおそれがある場合には、契約者はただちに自己の責任においてパスワードの変更を行うものとします。
        </li>
        <li>
          契約者等の責に帰すべき事由によるアカウント等の盗難、失念、第三者による使用などにより、当社が直接的または間接的に損害を被った場合には、本規約第27条の定めに従い、当社は当該損害の賠償を契約者に請求することができるものとします。
        </li>
      </ol>

      <h2>第10条　利用許諾</h2>
      <ol>
        <li>
          本アプリのほか本サービスに関連する一切の権利（著作権（著作権法第27条及び第28条に定める権利を含みます。）、商標権、特許権その他の知的財産権を含みますが、これらに限りません。）（以下「知的財産権等」といいます。）は、すべて当社に帰属します。
        </li>
        <li>
          当社は、契約者に対し、当社から提供される本アプリその他本サービスに付随するソフトウェアおよびサービス等について、本規約に定める条件で、日本国内における非排他的かつ非独占的な利用を許諾します。
        </li>
        <li>
          前項に定める許諾は、本サービスに関する当社の知的財産権等の譲渡、担保設定その他一切の処分を伴うものではありません。
        </li>
        <li>
          第2項に定める利用権は譲渡不能かつ再許諾不能のものであり、契約者は、当該利用権を第三者に譲渡し、または担保権の設定その他の処分を行うことはできないものとします。
        </li>
      </ol>

      <h2>第11条　契約者の商標等の使用許諾</h2>
      <br/>
      <p>
        契約者は、契約者による本サービスの利用期間中において、契約者の社名（法人名または組織・団体名に限ります。）、サービス名、ロゴマーク等を、本サービスに関する当社との取引実績として、当社または当社の委託先が運営するWebサイト、本サービスのパンフレット等に表記することを含めて、当社が本サービスの広告・宣言・ＰＲ・販売促進等を目的とした資料等に使用することをあらかじめ許諾するものとします。
      </p>
      <br/>

      <h2>第12条　契約期間および途中解約</h2>
      <ol>
        <li>
          本サービスの契約期間は、本サービスの利用申込み時に申請された利用開始日から1年間とし、契約者はこの期間中、本サービスを利用できるものとします。
        </li>
        <li>
          本契約は自動更新とし、契約期間満了の1か月前までに当社または契約者のいずれか一方から相手方に更新拒絶の意思表示がなされない場合には、本サービスは同一の条件でさらに1年間自動的に更新されるものとし、以降も同様とします。
        </li>
        <li>
          当社または契約者が本契約の解約を希望する場合には、相手方に対し、1か月前までに解約希望日を通知するものとします。
        </li>
        <li>
          本契約の解約日は、前項に従って通知された解約希望日の属する月の末日とします。契約者等は、その日まで解約の対象となる本サービスの利用が可能であり、契約者はその日までの利用料金を当社に支払うものとします。
        </li>
      </ol>

      <h2>第13条　本サービスの一時停止、利用停止および廃止</h2>
      <ol>
        <li>
          当社は、本サービスを提供するために必要な設備、機器、システム等の保守または工事を定期的にまたは緊急に行う場合には、契約者等に事前に連絡することなく、一時的に本サービスの全部または一部の利用を停止すること（以下「本サービスの一時停止」といいます。）があり、契約者はあらかじめこれを承諾するものとします。
        </li>
        <li>
          契約者は、本サービスの一時停止を受けた場合であっても、当社に対する当該期間中の料金の支払義務を負うものとします。ただし、1回あたりの連続した中断時間が24時間を超過した場合には、当該超過時間数に相当する料金（各回別かつ24時間毎に1日に換算して24時間未満の時間は切捨てとし、1か月を30日とする日割計算）については支払義務を負わないものとします。
        </li>
        <li>
          当社は、以下の各号のいずれかに該当する場合には、契約者等に事前に連絡することなく、契約者による本サービスの全部または一部の利用を停止すること（以下、「本サービスの利用停止」といいます。）があり、契約者はあらかじめこれを承諾するものとします。なお、当社は、第7号以下に規定する本サービスの利用停止の理由について一切の開示義務を負わないものとします。
          <br/>
          <p>
            (1) 本サービスを提供するために必要な設備、機器、システム等の全部または一部が滅失または復旧困難な程度に破損した場合
          </p>
          <p>
            (2) 電気通信事業者が提供する電気通信サービスの提供が中止、休止、停止または制限された場合
          </p>
          <p>
            (3) 火災、停電、通信回線事故その他当社のコントロール下にない事故により本サービスの提供ができなくなった場合
          </p>
          <p>
            (4) 地震、噴火、洪水、津波等の天災地変や戦争、暴動、騒乱、労働争議、パンデミック等その他不可抗力により本サービスの提供ができなくなった場合
          </p>
          <p>
            (5) 事前の想定が困難な技術的問題が生じた場合
          </p>
          <p>
            (6) その他、運用上、技術上または営業上、当社がやむを得ないと判断した場合
          </p>
          <p>
            (7) 契約者等が本規約の規定に違反する行為を行い、または行うおそれがあるものと当社が判断した場合
          </p>
          <p>
            (8) 本サービスの利用に伴う負担その他の債務の履行を遅滞し、または履行を拒絶した場合
          </p>
          <p>
            (9) 当社に提供された届出事項に虚偽または不備があることが発見された場合
          </p>
          <p>
            (10)過去に本サービスの利用資格を取り消されたことがあることが発見された場合
          </p>
          <p>
            (11)当社への必要書類の提出または質問への回答を拒んだ場合
          </p>
          <p>
            (12)不正な目的または方法により本サービスを利用するおそれがあると当社が判断した場合
          </p>
          <p>
            (13) 本サービスの提供に関する当社の業務の遂行または当社の設備、機器、システム等に著しい障害を及ぼし、または及ぼすおそれがある行為を行った場合
          </p>
          <p>
            (14)第23条第1項各号または第2項各号に該当し、または該当するおそれがあると当社が判断する場合
          </p>
          <p>
            (15)その他、契約者等の行為が当社の適正かつ円滑な業務の遂行に支障をきたすおそれがあるものと当社が判断した場合
          </p>
        </li>
        <li>
          契約者は、前項に基づいて本サービスの利用が停止された場合であっても本契約が解約その他の理由により終了しない限り、利用料金の支払義務を免れないものとします。また、本サービスの利用停止により契約者等に発生した損害について、当社は一切の責任を負わないものとします。
        </li>
        <li>
          当社は、次の各号のいずれかに該当する場合には、本サービスを廃止することができるものとします。
          <br/>
          <p>
            (1) 廃止日の60日前までに、契約者に事前通知した場合
          </p>
          <p>
            (2) 第3項第3号に定める事故および同第4号に定める不可抗力その他やむを得ない事由により本サービスを提供できず、復旧の見込みが困難と当社が判断した場合
          </p>
        </li>
        <li>
          前項に定める本件サービスの廃止により契約者等に生じた損害について、当社は一切の責任を負わないものとします。
        </li>
      </ol>

      <h2>第14条　契約解除</h2>
      <ol>
        <li>
          前条第3項第1号から第6号までに定める事由により本サービスの利用停止を受けた契約者は、本サービスの利用停止から1週間を経過してから当該利用停止が解除されるまでの間、当社に通知することにより、ただちに本契約を解除することができるものとします。
        </li>
        <li>
          前条第3項第7号から第14号までに定める事由により本サービスの利用停止を受けた契約者が、当社から一定の期間を定めて是正の催告を受けたにもかかわらず、当該期間内になお当該事由を解消しない場合には、当社は、契約者に通知することにより、ただちに本契約を解除することができるものとします。
        </li>
        <li>
          契約者または当社は、相手方が次の各号のいずれかに該当する場合には、催告その他何らの手続を要することなく本契約をただちに解除することができるものとします。
          <br/>
          <p>
            (1) 営業の廃止もしくは変更または解散の決議を行った場合
          </p>
          <p>
            (2) 監督官庁から営業免許又は営業登録の取消しの処分を受けた場合
          </p>
          <p>
            (3) 自ら振り出し、または引き受けた手形または小切手の不渡処分を受けるなど、支払停止状態に陥ったものと認められる場合、
          </p>
          <p>
            (4) 差押、仮差押、仮処分、租税滞納処分その他公権力の処分を受けた場合
          </p>
          <p>
            (5) 民事再生、会社更生、破産、特別清算等の法的整理手続もしくは競売を申し立てられ、または自ら民事再生、会社更生、破産、特別清算等の法的整理手続の申立てを行った場合
          </p>
          <p>
            (6) 重大な法令違反、公序良俗違反その他の社会的信用失墜行為を行った場合
          </p>
        </li>
        <li>
          第1項の規定により契約者が本契約を解除した場合には、契約者は前条第4項本文の規定にかかわらず解除日以降の利用料金の支払義務を免れるものとします。なお、同項ただし書の規定は適用されるものとし、また、解除により契約者に生じる損害について、当社は一切の責任を負わないものとします。
        </li>
        <li>
          契約者等の責に帰すべき事由により本契約が解除された場合には、契約者は本サービスの利用をただちに中止するとともに、当該中止した日の属する月の末日までの利用料金を当社に支払うものとします。
        </li>
        <li>
          第1項の規定により本契約が解除された場合を除き、解除をした当事者から相手方に対する損害賠償請求は妨げられないものとします。
        </li>
      </ol>

      <h2>第15条　仕様変更</h2>
      <ol>
        <li>
          契約者は、本サービスのバージョンアップにともない、機能の変更、操作方法の変更、名称変更、およびこれらに限定されない仕様変更を行う場合があることをあらかじめ承諾するものとします。
        </li>
        <li>
          契約者は、前項とは別に、本サービスの後継システムへの移行等、仕様の変更以外のシステムに関連する変更を行う場合があることをあらかじめ承諾するものとします。
        </li>
        <li>
          外部システムに連携する本サービスの一部が、外部システムの仕様変更等により、永続的に機能の再開が不可能な場合には、当社は、その旨を契約者に通知し、第13条第5項に従い本サービスを廃止することができるものとします。
        </li>
      </ol>

      <h2>第16条　第三者への委託</h2>
      <br/>
      <p>
        当社は、本規約における当社の義務と同等の義務を負わせることにより、本サービスの一部または全部を第三者に委託（当該第三者からの再委託を含みます。）することができるものとし、契約者はこの委託についてあらかじめ承諾するものとします。
      </p>
      <br/>

      <h2>第17条　個人情報保護</h2>
      <br/>
      <p>
        当社は、当社が公表している「個人情報保護方針（プライバシーポリシー）」に従い、個人情報の保護に関する法律（平成15年法律第57号）及び個人情報の保護に関するガイドラインその他関連法令等に従い、適正に取り扱います。
      </p>
      <br/>

      <h2>第18条　機密保持義務</h2>
      <ol>
        <li>
          契約者および当社は、本契約に関して秘密である旨の表示がなされた上で相手方に開示された情報（以下「機密情報」といい、機密情報を開示する当事者を「開示当事者」といいます。）を、開示当事者の事前の承諾なく、第三者に開示、漏洩等しないものとします。ただし、以下の各号に定める情報は「機密情報」に該当しないものとします。
          <br/>
          <p>
            (1) 開示当事者から開示された時点で、既に公知である情報
          </p>
          <p>
            (2) 開示当事者から開示された後、自己の責によらず公知となった情報
          </p>
          <p>
            (3) 正当な権限を有する第三者から、機密保持義務を負うことなく合法的に入手した情報
          </p>
          <p>
            (4) 開示当事者から開示された情報によることなく独自に開発した情報
          </p>
        </li>
        <li>
          前項に規定にかかわらず、法律、政令、条例その他法令の定めによる場合、裁判所その他公的機関から適法に機密情報の開示を命令された場合、弁護士、会計士その他法律上の守秘義務を負う専門家に対し、自己の権利を守り、または義務を履行する必要がある場合には、機密情報を開示できるものとします。ただし、本項に基づく開示は当該目的を達成するために必要最小限の範囲とし、開示をした当事者は、すみやかに開示をした事実、開示先およびその内容を開示当事者に通知するものとします。
        </li>
        <li>
          契約者および当社は、開示当事者から要求があった場合、ただちにすべての機密情報を当該開示当事者に返却し、または当該開示当事者の事前の書面による指示に従い、機密漏洩に十分に配慮した方法で廃棄します。
        </li>
      </ol>

      <h2>第19条　カスタマーに関する情報の取扱い</h2>
      <ol>
        <li>
          本アプリには、契約者がカスタマーの個人情報、写真データ等の各種情報（以下「カスタマー情報」といいます。）を収集し、管理する機能がありますが、当該機能を用いて契約者が収集したカスタマー情報は、契約者が保有する情報として契約者の責任において管理するものとし、当社は、本アプリの機能として提供する管理機能の範囲内でその限度において当該情報の管理を受託したものとして取り扱い、当社独自の目的でカスタマー情報を取り扱うことはありません。
        </li>
        <li>
          カスタマー情報に著作物や標章、デザインその他知的財産権の対象となるものが含まれる場合には、契約者は自己の責任と負担においてその利用にかかる権利処理を適法に行うものとし、本アプリの使用によってカスタマーその他カスタマー情報に関連する第三者に対して一切の損害を与えないものとします。
        </li>
        <li>
          契約者は、カスタマー情報に関し、個人情報の保護に関する法律（平成15年法律第57号）及び個人情報の保護に関するガイドライン、著作権法、商標法その他関連法令等を遵守し、自己の責任と負担においてカスタマー情報を適法かつ安全に管理するための適切な措置を講じるものとします。
        </li>
      </ol>

      <h2>第20条　情報の開示と統計データ・Cookieデータ等の取扱い</h2>
      <ol>
        <li>
          当社は、カスタマー情報を除き、契約者等による本サービスの利用に伴い当社に提供および記録された個人の年齢や性別等の属性情報および本サービスの利用履歴や行動履歴等の情報（本サービスを通じた一切の活動の過程、態様、その他に第三者による判断・入力等を行ったシステム内でのステータスの状況・変化や評価情報などを含みますが、これらに限りません。）について、個人を識別・特定できないよう加工した上で取り扱うこと（契約者等への情報提供、分析・研究・統計データ等の作成、属性情報等データの作成、企業等第三者への提供、市場の調査、本サービスの品質情報としての公開、新サービスの開発を含みますが、これらに限りません。）ができるものとし、契約者等はこの取扱いについてあらかじめ承諾するものとします。
        </li>
        <li>
          前項の規定にかかわらず、当社は、Cookieの情報に関しては自由に利用するものとし、契約者等はこれをあらかじめ承諾するものとします。なお、契約者および当社は、Cookieに保存されている情報のみでは契約者等の個人を特定できないことを相互に確認するものとします。
        </li>
      </ol>

      <h2>第21条　禁止事項および注意事項</h2>
      <ol>
        <li>
          契約者等は、本サービス（本サービスに関するコード、ドキュメント等の一切を含みます。）の利用において、次の各号に該当する行為を行ってはいけません。
          <br/>
          <p>
            (1) 法令に違反する行為
          </p>
          <p>
            (2) 公序良俗に反する行為
          </p>
          <p>
            (3) 政治的又は宗教的思想を含む情報を提供する行為及び政治的又は宗教的な勧誘を行う行為
          </p>
          <p>
            (4) 他の契約者等、第三者又は当社に対し、財産権（知的財産権を含みます。）の侵害、名誉・プライバシーの侵害、誹謗中傷、その他の不利益を与える行為
          </p>
          <p>
            (5) 本アプリを複製又は複写する行為
          </p>
          <p>
            (6) 本アプリを改変し、若しくはリバースエンジニアリング（主に、内容を解析して人間が読み取り可能な形に変換する行為）、逆コンパイル、逆アセンブルする行為
          </p>
          <p>
            (7) 本アプリ内のデータを操作又は変更する行為
          </p>
          <p>
            (8) 本アプリに影響を与える外部ツールの利用・作成・頒布・販売等を行う行為
          </p>
          <p>
            (9) 本アプリの運営を妨害する行為
          </p>
          <p>
            (10)当社が本来意図しない動作や外部ツールを意図的に利用して、本アプリでの利益を得ようとする行為
          </p>
          <p>
            (11)サーバその他当社のコンピュータに不正にアクセスする行為
          </p>
          <p>
            (12)虚偽の登録内容等を申請する行為
          </p>
          <p>
            (13)他の契約者等のアカウントを利用する行為
          </p>
          <p>
            (14)携帯端末等を貸与して行う操作行為
          </p>
          <p>
            (15)第三者になりすまして本アプリを利用する行為
          </p>
          <p>
            (16)アカウントを転売その他譲渡する行為
          </p>
          <p>
            (17)自ら同一または類似の業務またはサービスの提供を行い、または第三者に行わせる行為
          </p>
          <p>
            (18)当社の競業先又は競業先に所属し、本アプリを調査する目的で利用する行為、競合するサービスを宣伝する行為
          </p>
          <p>
            (19)本アプリを模倣したアプリ若しくは個別サービスの制作、準備を目的とした利用行為
          </p>
          <p>
            (20)当社が本サービスの利用を終了させた後、当社の事前の許可なくアカウントを発行保有する行為
          </p>
          <p>
            (21)前各号の行為を直接若しくは間接に惹起し、又は容易にする行為
          </p>
          <p>
            (22)その他当社が不適切と判断する行為
          </p>
        </li>
        <li>
          契約者等は、本アプリの盗難、紛失、破壊等の防止に必要な合理的措置を講じなければならないものとします。
        </li>
        <li>
          契約者が、本サービスの提供を受けるにあたり、契約者等が行うべき作業等を第三者に委託する場合には、当該第三者に本規約における契約者等と同等の義務を負わせた上で、事前の書面による当社の承諾を得なければならないものとします。なお、当社が、当該第三者が当該義務を履行しない、または履行しないおそれがあると判断した場合には、当社は、当該第三者への作業等の委託の全部または一部を認めないことができるものとします。
        </li>
      </ol>

      <h2>第22条　権利義務譲渡の禁止</h2>
      <br/>
      <p>契約者は、本契約に基づく契約者の権利および義務の全部または一部を、当社の事前の書面による承諾なくして第三者に譲渡し、移転しまたは担保の用に供してはならないものとします。</p>
      <br/>

      <h2>第23条　損害賠償</h2>
      <ol>
        <li>
          契約者等は、当社に対し、本規約に定める内容に従い、当社の責に帰すべき事由により契約者等が直接かつ現実に被った通常の損害について、当該損害が発生した日の属する月の前月に支払済みの利用料金の１か月分を上限とし、損害賠償の請求をすることができるものとします。
        </li>
        <li>
          契約者および当社は、個人情報や機密情報の漏洩等により相手方に損害を与えた場合は、当該漏洩等に基づいて相手方が直接かつ現実に被った通常の損害について賠償するものとします。ただし、賠償金額の上限は、契約者が当社に対して過去1年間に支払った本サービスの料金の合計額を上限とし、当該料金の支払いが1年間に満たない場合には、その期間に支払った料金の合計額を上限とします。
        </li>
      </ol>

      <h2>第24条　反社会的勢力排除</h2>
      <ol>
        <li>
          契約者および当社は、次の各号のいずれにも該当しないことを表明および保証し、かつ将来にわたっても該当しないことを確約します。
          <br/>
          <p>
            (1) 自らまたは自らの役員、代理人もしくは使用人（以下「役員等」といいます。）または委託先もしくは下請け（以下「委託先等」といいます。）が、暴力団、暴力団員、暴力団員でなくなった時から5年を経過しない者、暴力団準構成員、暴力団関係企業、総会屋、社会運動標ぼうゴロまたは特殊知能暴力集団等その他これらに準ずる者（以下、総称して「暴力団員等」といいます。）であること
          </p>
          <p>
            (2) 暴力団員等が実質的に経営を支配していると認められる関係を有すること
          </p>
          <p>
            (3) 暴力団員等が経営に実質的に関与していると認められる関係を有すること
          </p>
          <p>
            (4) 自ら若しくは第三者の不正の利益を図る目的または第三者に損害を加える目的をもってするなど、暴力団員等を利用していると認められる関係を有すること
          </p>
          <p>
            (5) 暴力団員等に対して資金等を提供し、または便宜を供与するなどの関与をしていると認められる関係を有すること
          </p>
          <p>
            (6) 自らの役員等もしくは自らの経営に実質的に関与している者または委託先等が暴力団員等と社会的に非難されるべき関係を有すること
          </p>
        </li>
        <li>
          契約者および当社は、自らまたは第三者を利用して次の各号のいずれかに該当する行為を行なわないことを保証します。
          <br/>
          <p>
            (1) 暴力的な要求行為
          </p>
          <p>
            (2) 法的な責任を超えた不当な要求行為
          </p>
          <p>
            (3) 取引に関して、脅迫的な言動をし、または暴力を用いる行為
          </p>
          <p>
            (4) 風説を流布し、偽計を用いまたは威力を用いて相手方の信用を毀損し、または相手方の業務を妨害する行為
          </p>
          <p>
            (5) その他前各号に準ずる行為
          </p>
        </li>
        <li>
          契約者および当社は、前項各号に違反する事実が判明した場合には、相手方にただちに通知するものとします。
        </li>
        <li>
          契約者または当社は、相手方の役員等もしくは経営に実質的に関与している者または委託先等が、第1項各号のいずれかに該当し、もしくは前項各号のいずれかに該当する行為をし、または第1項の規定に基づく表明及び確約に関して虚偽の申告をしたことが判明した場合には、催告等何らの手続を要することなく、ただちに相手方に通知して、本契約を解除することができるものとします。
        </li>
        <li>
          契約者または当社は、本規約に別に定める規定の有無にかかわらず、前項の規定に基づいて本契約を解除した場合には、相手方に対し一切の損害賠償責任を負わないものとします。
        </li>
        <li>
          契約者または当社は、相手方が本条の規定に違反したことにより損害を被った場合には、相手方に対し、契約解除の有無にかかわらず当該損害について損害賠償を請求できるものとします。
        </li>
      </ol>

      <h2>第25条　免責</h2>
      <ol>
        <li>
          当社は、本サービスにおいて提供するサービス内容について、契約者等に対するアドバイス、コンサルティング、説明等の義務を負担せず、当社が本サービスの提供に付随して契約者等に行ったアドバイス、コンサルティング、説明等について、当社は一切の責任を負わないものとします。
        </li>
        <li>
          火災、停電、通信回線事故その他当社のコントロール下にない事故、または地震、噴火、洪水、津波等の天災地変や戦争、暴動、騒乱、労働争議、パンデミック等その他不可抗力によって本サービスの提供が不能となり、または遅延した場合であっても、当社は一切の責任を負わないものとします。
        </li>
        <li>
          契約者は、本サービスが、当社がその時点で保有している状態で提供するものであり、契約者等が予定している利用目的への適合性および完全性、本アプリにバグ等の不具合がないこと、さらには不具合の修正、改良等の実施を行う義務はないことを含めて、一切の保証または条件を伴わずに現状で利用許諾されることについて、あらかじめ承諾するものとします。また、当社は、本サービスの利用およびその成果の的確性、正確性、信頼性、最新性、本アプリにバグ等の不具合がないことに関して、契約者等に対していかなる明示または黙示の担保責任も負担しないものとし、さらには、バグ等により契約者等に対して生じた損害について、当社は一切の責任を負わないものとします。
        </li>
        <li>
          本サービスの利用または本サービスを利用できなかったことにより生じた直接的、付随的または間接的損害、データ・プログラムその他の無体財産に対する損害(利益の喪失、中断、情報の喪失等による損害を含む)等について、本規約において明示的に定める場合を除き、当社は一切の責任を負わないものとします。
        </li>
        <li>
          契約者等が登録を申請した事項もしくは契約者等が自ら登録した事項に誤りがあること、または契約者等が登録すべき事項を登録しなかったことにより、契約者等に損害が生じた場合には、当社は一切の責任を負わないものとします。また、契約者等が当社に対して提供すべき各種情報等について提供を怠った場合においても、同様に当社は一切の責任を負わないものとします。
        </li>
        <li>
          契約者等が本サービスの利用結果を受領後、自らデータまたは成果物を加工、編集等したことにより、契約者等に損害が生じた場合には、当該損害の発生について当社は一切の責任を負わないものとします。
        </li>
        <li>
          契約者等の設備の障害またはインターネット接続サービスの不具合等、接続環境の障害により生じた損害について、当社は一切の責任を負わないものとします。
        </li>
        <li>
          インターネット接続サービスの性能値に起因する損害について、当社は一切の責任を負わないものとします。
        </li>
        <li>
          当社が導入している通常講ずべきコンピューターウィルス対策ソフトを超えたコンピューターウィルス等の被害について、当社は一切の責任を負わないものとします。
        </li>
        <li>
          当社による善良なる管理者の注意をもってしても防御し得ない、本サービスへの第三者による不正アクセス、アタックまたは通信経路上での傍受等により生じた損害について、当社は一切の責任を負わないものとします。
        </li>
        <li>
          当社による提供物以外のソフトウェア、ハードウェア、データベースまたは周辺機器類に起因して生じた損害について、当社は一切の責任を負わないものとします。
        </li>
        <li>
          本サービスの利用に関するユーザーまたはカスタマーと契約者との間の申告、苦情、調停、訴訟その他あらゆるトラブルについて、当社は一切の関与を行わず、また、一切の責任を負わないものとします。
        </li>
        <li>
          前各号に定めるほか、当社の責に帰すべからざる事由による損害について、当社は一切の責任を負わないものとします。
        </li>
        <li>
          契約者等が本サービスを利用することにより第三者に対して損害を与えた場合または紛争が生じた場合には、契約者等の責任と費用負担において当該紛争を処理解決するものとし、契約者等は当社に対し一切の負担を負わせないものとします。
        </li>
        <li>
          前項の規定にもかかわらず、契約者等の責任と費用負担で当該紛争の早期解決が出来ない事態が生じた場合には、契約者は、当社において紛争解決に要した一切の費用(解決のために当社に発生する合理的な弁護士費用等も含みますが、これらに限定されません。)を契約者等が連帯して支払うことにあらかじめ同意します。
        </li>
      </ol>

      <h2>第26条　通知方法</h2>
      <ol>
        <li>
          契約者は、当社から受け取る連絡または通知について、本規約に従って適切に本サービスを利用するために当社が契約者等に通知または連絡する必要があると判断した場合には、第2項から第4項に定める方法および条件にて受領することをあらかじめ承諾するものとします。
        </li>
        <li>
          当社から契約者等に対する通知または連絡は、本規約に特に定めのない限り、本サービスのWebサイトの画面上での通知か、登録メールアドレスまたは本サービスで使用する電子メールアドレス宛に、電子メールを送信する方法により行います。
        </li>
        <li>
          当社が、本サービスのWebサイトの画面上への掲載により契約者等に通知または連絡を行う場合には、当該通知または連絡を掲載してから24時間を経過したときに、電子メールによる通知または連絡を行う場合には、当社が契約者に当該メールを発信したときに、それぞれその通知または連絡の効力を生じるものとします。
        </li>
        <li>
          当社が契約者等に対して前項記載の方法により通知または連絡した場合において、契約者等が当社からの通知または連絡を確認しなかったとしても（通知または連絡が契約者に到達しなかった場合を含みます。）、それにより契約者等に発生した損害について、当社は一切の責任を負わないものとします。
        </li>
        <li>
          契約者等が当社へ通知または連絡をする場合には、登録メールアドレスから当社宛に電子メールを発信する方法により行うものとします。契約者等からの通知または連絡は、当該メールを当社が受信したときに、それぞれその通知または連絡の効力を生じるものとします。
        </li>
      </ol>

      <h2>第27条　存続条項</h2>
      <br/>
      <p>本契約の終了後も、本条は有効に存続するものとします。</p>
      <br/>

      <h2>第28条　準拠法</h2>
      <br/>
      <p>本契約の準拠法は日本法とし、本契約のすべての規定には日本国の法令が適用され、かつ執行されるものとします。</p>
      <br/>

      <h2>第29条　分離可能性</h2>
      <br/>
      <p>
        本規約の条項のいずれかが管轄権を有する裁判所によって違法または無効であると判断された場合であっても、本規約のその他の条項はなお有効なものとして解釈および適用されるものとします。
      </p>
      <br/>

      <h2>第30条　合意管轄</h2>
      <br/>
      <p>
        本契約または本サービスに関する一切の紛争については、東京地方裁判所を第一審の専属的合意管轄裁判所とします。
      </p>
      <br/>

      <h2>第31条　誠実協議</h2>
      <br/>
      <p>
        本契約に定めのない事項が発生した場合、または本契約上の解釈に疑義が生じた場合は、契約者と当社とは、お互い誠意を持って協議し、解決を図るものとします。
      </p>
    </FullScreenDialog>
  );
};

export default TermsOfServiceDialog;
